module.exports = __webpack_public_path__ + "media/map/Map_No_Icons-03e2e792.png";